<template>
  <textarea class="itextarea_item"
    :value="value"
    :name="name"
    :placeholder="placeholder"
    :rows="rows"
    v-on="inputListeners"
    @focus="handleFocus"
    @blur="onBlur"
  ></textarea>
</template>

<script>
export default {
  name: 'ITextArea',
  props: {
    value: String,
    name: {
      type: String,
      default: 'textareaName'
    },
    placeholder: {
      type: String,
      default: 'placeholder'
    },
    rows: {
      type: Number,
      default: 3
    }
  },
  computed: {
    inputListeners() {
      const vm = this;
      return Object.assign({},
        this.$listeners,
        {
          input(evt) {
            vm.$emit('input', evt.target.value);
          }
        }
      );
    }
  },
  methods: {
    handleFocus() {
      this.$emit('handleFocus');
    },
    onBlur() {
      this.$emit('onBlur');
    }
  },
};
</script>

<style scoped lang="stylus">
$grayCorlor = #C2C2CC
.itextarea_item {
  width 100%
  line-height 20px
  font-size $fontSizeMiddle
  border none
  color #41414D
  font-weight 500
}
::placeholder {
  font-weight 400
  color $grayCorlor
}
</style>
